export default __webpack_public_path__ + "static/media/SENAIT_FR_INTRO.e04036a0.mp3";